import styled, { css } from 'styled-components';
import { StandardButton } from '@gv/triage-components';

export const Container = styled.div`
  gap: 16px;
  width: 100%;
  padding: 16px;
  display: flex;
  border-radius: 16px;
  flex-direction: column;
  ${({ theme }) => css`
    border: 1px solid ${theme.colors.grey.secondary.standard};
    background-color: ${theme.config.background};
  `}
`;

export const Button = styled(StandardButton)`
  min-width: fit-content;
`;
